import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import close from "../../../../../assets/close.svg";
import { withTranslation, Trans } from "react-i18next";
import {
  OrderondemandAction,
  OrderEditondemandAction,
  OrderEditPickupDropOffondemandAction,
  OrderEditPickupDropOffPickupAction,
  OrderEditPickupDropOffDeliveryAction,
  OrderEditPickupDropOffPickupDeliveryAction,
  OrderInfoAction,
} from "../../../../../Redux/actions/actions";
import { get_id, get_currencyCode, get_lang } from "../../../../../helper/UserData/userdate";
import {
  Edit_Travel_Set_Price,
  Edit_Travel_Operate_Changed,
  Edit_Travel_Reset,
} from "../../../../../Redux/actions/actionNames";
// import ChangeMethod from "./changeMethod";
import momentJalaali from "moment-jalaali";
import { isArray, isBoolean, isEmpty, isNumber } from "lodash";
import { padding, position } from "polished";
import PaymentIcon from "react-payment-icons-inline";
import walletFooter from "../../../../../assets/walletFooter.svg";
import by_receiver from "../../../../../assets/by_receiver.svg";
import walletall from "../../../../../assets/walletall.svg";
import cash from "../../../../../assets/cash.svg";
import styles from './dropoff.module.css';
import Button from "../../../../../design-system/lib/Button";
import Typography from "../../../../../design-system/lib/Typography";
import { INFO_CIRCLE } from "../../../../../assets";
 import { OrderEditPickupDropoffDelivey_CF, OrderEditPickupDropoffondemand_CF, OrderEditPickupDropoffPickup_CF, OrderEditPickupDropoffPickupDelivey_CF } from "../../../../../helper/api";
import { snack } from "../../../../../utils/SnackbarUtilsConfigurator";

var numeral = require("numeral");

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }


  priceOnChnage = (e) => {
    this.props.dispatch(Edit_Travel_Operate_Changed());
    !this.props.price.loading &&
      this.props.dispatch(Edit_Travel_Set_Price(e.target.value, true));
  };

validateRequiredCustomFields = (filterdcustomFieldDefinitions, customField) => {
  const errors = [];

  filterdcustomFieldDefinitions.forEach(field => {
    // اگر خود فیلد یا config وجود نداشت => بیخیال
    if (!field || !field.config) return;

    const { key, config, label: rawLabel, isRequired } = field;

    // اگر key نداشت هم skip
    if (!key) return;

    const value = customField?.[key];
    const label = rawLabel || key;

    // ---------- REQUIRED ----------
    if (isRequired && (value === undefined || value === null || value === "")) {
      errors.push(`${label} الزامی است`);
      return;
    }

    // اگر مقدار خالیه و required نیست => اصلاً validate نکن
    if (value === undefined || value === null || value === "") return;

    // ---------- TEXT ----------
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") return;

      if (config.minLength != null && value.length < config.minLength) {
        errors.push(`${label} حداقل ${config.minLength} کاراکتر`);
      }

      if (config.maxLength != null && value.length > config.maxLength) {
        errors.push(`${label} حداکثر ${config.maxLength} کاراکتر`);
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        errors.push(`${label} فرمت معتبر نیست`);
      }
    }

    // ---------- EMAIL ----------
    if (config.type === "email") {
      if (typeof value !== "string") return;

      const emailRegex = /^\S+@\S+\.\S+$/;
      if (!emailRegex.test(value)) {
        errors.push(`${label} ایمیل معتبر نیست`);
      }
    }

    // ---------- PHONE ----------
    if (config.type === "phone") {
      if (value?.toString()?.length < 7) {
        errors.push(`${label} معتبر نیست`);
      }
    }

    // ---------- NUMBER ----------
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        errors.push(`${label} باید عدد باشد`);
        return;
      }

      if (config.min != null && num < config.min) {
        errors.push(`${label} حداقل ${config.min}`);
      }

      if (config.max != null && num > config.max) {
        errors.push(`${label} حداکثر ${config.max}`);
      }
    }

    // ---------- DECIMAL ----------
    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        errors.push(`${label} باید عدد باشد`);
        return;
      }

      if (config.min != null && num < config.min) {
        errors.push(`${label} حداقل ${config.min}`);
      }

      if (config.max != null && num > config.max) {
        errors.push(`${label} حداکثر ${config.max}`);
      }

      if (config.precision != null) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          errors.push(`${label} حداکثر ${config.precision} رقم اعشار`);
        }
      }
    }

    // ---------- SELECT ----------
    if (config.type === "select") {
      if (!Array.isArray(config.choices)) return;

      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        errors.push(`${label} انتخاب نامعتبر`);
      }
    }

    // ---------- FILE ----------
    if (config.type === "file") {
      if (!(value instanceof File)) return;

      if (config.maxSizeMB != null) {
        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          errors.push(`${label} حداکثر ${config.maxSizeMB}MB`);
        }
      }

      if (Array.isArray(config.allowedTypes) && config.allowedTypes.length) {
        if (!config.allowedTypes.includes(value.type)) {
          errors.push(`${label} نوع فایل مجاز نیست`);
        }
      }
    }

    // ---------- DATE ----------
    if (config.type === "date" || config.type === "dateTime") {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        errors.push(`${label} تاریخ معتبر نیست`);
      }
    }

    // ---------- JSON ----------
    if (config.type === "json") {
      if (typeof value !== "string") return;

      try {
        JSON.parse(value);
      } catch {
        errors.push(`${label} JSON معتبر نیست`);
      }
    }
  });

  if (errors.length > 0) {
    console.log("validation errors:", errors);
    return false;
  }

  return true;
};
    showRequirdalert = () => {
    let yy = false;

    try {
      this.props.customFieldDefinitions
        .filter(item => item.stage === "orderCreation" && item.isRequired)
        .forEach(item => {
          if (!this.props.customField[item.key]) {
            yy = true;
          }
        });

      return yy;
    } catch (error) {
      return false;
    }
  };


  EditOrder = () => {

       this.setState({ loading: true })

      if (this.props.orderType == "Ondemand") {
        return this.EditOndemand(this.props)
      } else if (this.props.orderType == "Pickup") {
        return this.EditPickup(this.props)
      } else if (this.props.orderType == "Delivery") {
        return this.EditDelivery(this.props)
      } else if (this.props.orderType == "PickupDelivery") {
        return this.EditPickupDelivery(this.props)
      }

 
  };

  EditOndemand = (props) => {
 
    OrderEditPickupDropoffondemand_CF(props.dispatch, jsonToFormData({
      dispatcherId: get_id(),
      customFields: props.OrderCustomfield || {},
      ...(props.serviceactiveVehicleType?.setting?.isReferenceIdActive
        ? { referenceId: props.REFREV }
        : {}),
    }), props.id, (call) => {
      this.setState({ loading: false })

      if (call) {

         

        props.dispatch(Edit_Travel_Reset());
        props.dispatch(
          OrderInfoAction(props.dispatch, {
            orderId: props.id,
          })
        );
      }

    })



    
  }

  EditPickupDelivery = (props) => {

  
 
    OrderEditPickupDropoffPickupDelivey_CF(props.dispatch, jsonToFormData({
      dispatcherId: get_id(),
      note: props.notess,

      customFields: props.OrderCustomfield || {},
      ...(props.serviceactiveVehicleType?.setting?.isReferenceIdActive
        ? { referenceId: props.REFREV }
        : {}),
    }), props.id, (call) => {
      this.setState({ loading: false })

      if (call) {

         

        props.dispatch(Edit_Travel_Reset());
        props.dispatch(
          OrderInfoAction(props.dispatch, {
            orderId: props.id,
          })
        );
      }

    })
  }

  EditPickup = (props) => {

 

    OrderEditPickupDropoffPickup_CF(props.dispatch, jsonToFormData({
      dispatcherId: get_id(),
      customFields: props.OrderCustomfield || {},
      ...(props.serviceactiveVehicleType?.setting?.isReferenceIdActive
        ? { referenceId: props.REFREV }
        : {}),
    }), props.id, (call) => {
      this.setState({ loading: false })

      if (call) {

         

        props.dispatch(Edit_Travel_Reset());
        props.dispatch(
          OrderInfoAction(props.dispatch, {
            orderId: props.id,
          })
        );
      }

    })
  }

  EditDelivery = (props) => {
 


    OrderEditPickupDropoffDelivey_CF(props.dispatch, jsonToFormData({
      dispatcherId: get_id(),
      customFields: props.OrderCustomfield || {},
      ...(props.serviceactiveVehicleType?.setting?.isReferenceIdActive
        ? { referenceId: props.REFREV }
        : {}),
    }), props.id, (call) => {
      this.setState({ loading: false })

      if (call) {

         

        props.dispatch(Edit_Travel_Reset());
        props.dispatch(
          OrderInfoAction(props.dispatch, {
            orderId: props.id,
          })
        );
      }

    })
  }


  IsActiveFooterBtn = () => {
    // this.props.price.loading ? 
    // "grey"
    // // : !this.props.price.done ?
    // // "grey" 
    // : this.props.operatorChanged  ?
    // "":
    // "grey"

    // (this.props.auto
    //   ? !this.props.price.done ||
    //     !this.props.operatorChanged ||
    //     this.props.sendOrder.loading
    //   : !this.props.price.done ||
    //     !this.props.operatorChanged ||
    //     this.props.sendOrder.loading ||
    //     !this.props.manual_id) && "grey"



  }


  render() {
    return (
      <nRFooter style={{ boxShadow: "unset", height: "44px", position: "absolute", width: "400px" }}>

         <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", gap: "6px", width: "calc(100% - 24px)", direction: "ltr", height: "44px", margin: "0 12px" }}>
      

          <Button style={{ marginInlineStart: "auto", padding: "7px 10px" }} size="Medium" type="Primary" disabled={!this.validateRequiredCustomFields(this.props.customFieldDefinitions.filter(item => item.stage === "orderCreation") ,this.props.customField)} isLoading={this.state.loading} text={this.props.t("save")} onClick={this.EditOrder} />

        </div> 
        {(this.props.sendOrder.canSaveOrder) ? <> </> : <>
          <Typography weight="Body_Middle_Medium" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "8px", direction: "initial", float: "inherit", marginTop: "13px", marginInlineStart: "16px" }} text={<> <img style={{ float: "inlineStart" }} src={INFO_CIRCLE} /> {this.props.t("Fill in or Select")} <span style={{ color: "red" }}>*</span> {this.props.t("Fields")}</>} />

        </>}




      </nRFooter>
    );
  }
}

const mapStateToProps = (state) => ({
  id: state.EditOrder.editOrder.id,
  currencyCode: state.ViewTravel.pureData
    ? state.ViewTravel.pureData.currencyCode
    : "",
  ViewTrvelprice: state.ViewTravel.pureData
    ? state.ViewTravel.pureData.price
    : "",
  schedulePickupNow: state.ViewTravel.pureData ? state.ViewTravel.pureData.pickup.schedulePickupNow : false,
  type: state.ViewTravel.pureData.type,
  status: state.ViewTravel.pureData.status,
  code: state.ViewTravel.pureData.code,
  price: state.EditOrder.editOrder.price,
  sendOrder: state.EditOrder.editOrder.editOrder,
  operatorChanged: state.EditOrder.operatorChanged,
  customer: state.EditOrder.editOrder.customer,
  serviceactiveVehicleType: state.ViewTravel.pureData.service,
  serviceoptions: state.EditOrder.editOrder.service.options,
  auto: state.EditOrder.editOrder.driver.auto,
  driveroptions: state.EditOrder.editOrder.driver.options,
  auto_activeVehicleType:
    state.EditOrder.editOrder.driver.auto_driver.auto_activeVehicleType,
  manual_name: state.EditOrder.editOrder.driver.manual_driver.manual_name,
  manual_family:
    state.EditOrder.editOrder.driver.manual_driver.manual_family,
  manual_id: state.EditOrder.editOrder.driver.manual_driver.manual_id,
  manual_activeVehicleType:
    state.EditOrder.editOrder.driver.manual_driver.manual_activeVehicleType,
  pickup: state.EditOrder.editOrder.pickup,
  pickupadresss_loc: state.EditOrder.editOrder.pickup.adresss_loc,
  firstDropOff: state.EditOrder.editOrder.dropOffs.firstDropOff,
  firstDropOffadresss_loc:
    state.EditOrder.editOrder.dropOffs.firstDropOff.adresss_loc,
  otherdropOffs: state.EditOrder.editOrder.dropOffs.otherDropOffs,
  paymentMethod: state.EditOrder.paymentMethod,
  baseFarePrice: state.EditOrder.baseFarePrice,
  surcharges: state.EditOrder.surcharges,
  orderType: state.ViewTravel.pureData
    ? state.ViewTravel.pureData.type
      ? state.ViewTravel.pureData.type
      : null
    : null,
  isScheduled: state.ViewTravel.pureData ? state.ViewTravel.pureData.isScheduled : false,
  datapureData: state.ViewTravel.pureData,
  OrderCustomfield: state.NewOrder.newOrder.customField,
  REFREV: state.NewOrder.newOrder.referenceID,
  notess: state.NewOrder.newOrder.notes,

    customField: state.NewOrder.newOrder.customField,
  customFieldDefinitions: state.ViewTravel.pureData.customFieldDefinitions

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));




function DetectIsSchedule(dropOff) {
  let IsSchedule = false
  if (isArray(dropOff)) {
    dropOff.forEach((item) => {
      if ((Number(item.scheduleDateBefore) > 0) || (Number(item.scheduleDateAfter)) > 0) {
        IsSchedule = true
      }
    })
    return IsSchedule
  } else {
    if ((Number(dropOff.scheduleDateBefore) > 0) || (Number(dropOff.scheduleDateAfter)) > 0) {
      return true
    } else {
      return false

    }
  }


}





 function jsonToFormData(obj, formData = new FormData(), parentKey = "") {

  console.log("jsonToFormData ",obj)
  for (const key in obj) {
    const value = obj[key];

    // ⛔ null / undefined
    if (value === undefined) continue;

    const formKey = parentKey ? `${parentKey}[${key}]` : key;
    

  

    // 📎 فایل
    if (value instanceof File) {
      formData.append(formKey, value);
    }
    // 📚 آرایه → JSON
    else if (Array.isArray(value) && key != "dropoffs") {
      formData.append(formKey, JSON.stringify(value));
    }
    // 🧩 آبجکت
    else if (typeof value === "object") {

      if (value.mimetype) {
        continue
      }
      jsonToFormData(value, formData, formKey);
    }
    // 🔤 primitive
    else {

      if (value === null || (isEmpty(value) && !isBoolean(value) && !isNumber(value))) {
        formData.append(formKey, "null");

      } else {
        formData.append(formKey, value);
      }

    }
  }

  return formData;
}